module.exports = __webpack_public_path__ + "img/node-icon.00b2db9e.svg";